import { create } from 'zustand';

interface AnalysisMenuState {
  // État du chargement
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;

  // État vide (aucune analyse disponible)
  isEmpty: boolean;
  setIsEmpty: (empty: boolean) => void;

  // Erreur
  error: string | null;
  setError: (error: string | null) => void;

  // Recherche
  searchQuery: string;
  setSearchQuery: (query: string) => void;

  // Reset
  reset: () => void;
}

export const useAnalysisMenuStore = create<AnalysisMenuState>((set) => ({
  // État initial
  isLoading: false,
  isEmpty: false,
  error: null,
  searchQuery: '',

  // Actions
  setIsLoading: (loading) => set({ isLoading: loading }),
  setIsEmpty: (empty) => set({ isEmpty: empty }),
  setError: (error) => set({ error }),
  setSearchQuery: (query) => set({ searchQuery: query }),

  // Reset vers l'état initial
  reset: () =>
    set({
      isLoading: false,
      isEmpty: false,
      error: null,
      searchQuery: '',
    }),
}));
